module.exports = __webpack_public_path__ + "img/members.61fbead9.svg";